jQuery(function(){
	
	//select all the a tag with name equal to modal
	jQuery('a[name=modal]').click(function(e) {
		//Cancel the link behavior
		e.preventDefault();
		
		//Get the A tag
		var id = $(this).attr('href');
	
		//Get the screen height and width
		var maskHeight = $(document).height();
		var maskWidth = $(window).width();
	
		//Set heigth and width to mask to fill up the whole screen
		$('#mask').css({'width':maskWidth,'height':maskHeight});
		
		//transition effect		
		$('#mask').fadeIn(1000);	
		//$('#mask').fadeTo("fast",0.5);	
	
		//Get the window height and width
		var winH = $(window).height();
		var winW = $(window).width();
              
		//Set the popup window to center
		$(id).css("position","absolute");
		$(id).css('top',20 +'px');
		$(id).css("left", ( $(window).width() - $(id).width() ) / 2+$(window).scrollLeft() + "px");

	
		//transition effect
		$(id).fadeIn(1000); 
	
	});
	
	//if close button is clicked
	$('.window .close').click(function (e) {
		//Cancel the link behavior
		e.preventDefault();
		
		$('#mask').hide();
		$('.window').hide();
	});		
	
	//if mask is clicked
	$('#mask').click(function () {
		$(this).hide();
		$('.window').hide();
	});	
	
	
	
	// Menu
	jQuery('ul.sf-menu').superfish({ 
	   delay:       100,                            	// one second delay on mouseout 
		animation:   {opacity:'show',height:'show'},  	// fade-in and slide-down animation 
		speed:       'fast',                          // faster animation speed 
		autoArrows:  false,                           	// disable generation of arrow mark-up 
		dropShadows: false                            	// disable drop shadows 
	
	});
	
    // $('#searchbox').hide();
   
    // $('#showsearch').click(function() {
       //  $('#searchbox').show();
    // });
    $('#showsearch').click(function() {
    $('#showsearch').hide();
        $('#searchbox input').fadeIn(300,function() {
        // Animation complete
        //alert("welcome");
     $('input#search-input').focus()
        
      });

    });

    $('input#search-input').blur(function() {
            $('#searchbox input').fadeOut('medium', function() { 
                        $('#showsearch').fadeIn('fast');    
            }); 
    });


				
	   $('.item a').click(function () {
			$(this).parent().find('.item-content').slideToggle("fast");
			$(this).toggleClass("minus");
		});	

});